import React from "react";
import Header from '../../organism/Header';
import ButtonBase from 'ui-coopeuch-button';

import CardBase from 'ui-coopeuch-cardbase';


import errorImg from "../../../assets/img/user-error.svg";
import  ContenedorError  from './styles';

import "./styles.js";

const errorAutorizacion = () =>{

    const onSubmitHandle = () =>{
        window.location.href = 'https://www.coopeuch.cl';
    }
    return (
      <>
      <Header mostrarBanner={'false'} />
       <ContenedorError className="contenedor-error">
         <CardBase title="Autorización">
           <div className="error-info">
             <img src={errorImg} alt="error-autorizacion" />
             <h2>¡Algo salio mal!</h2>
             <p>No se ha podido realizar el pago.</p>
             <ButtonBase type="primary" label="Ir a Coopeuch" onClick={onSubmitHandle} />
           </div>
          </CardBase>
       </ContenedorError>
       </>
    );
  }

export default errorAutorizacion;
